module.exports = __webpack_public_path__ + "img/ep6-1.56f2ef8f.png";